export default {
  path: '/safety-supervision',
  title: '安全监督',
  title_EN: 'Safety Supervision',
  icon: 'mdi-shield-check',
  access: '安全监督',

  children: [
    {
      title: '船舶检查',
      icon: 'mdi-shield-check',
      group: '/security-inspect',
      children: [
        {
          path: '/security-inspect/safety-security-check-list',
          name: 'safety-security-check-list',
          component: () =>
            import(
              '@/views/safety-supervision/inspect/safety-security-check-list.vue'
            ),
          meta: {
            title: '安全检查',
            access: '船舶检查:列表',
          },
        },
        {
          path: '/security-inspect/safety-security-check-detail/:id',
          name: 'safety-security-check-detail',
          component: () =>
            import(
              '@/views/safety-supervision/inspect/safety-security-check-detail.vue'
            ),
          meta: {
            title: '安全检查-详情',
            access: '船舶检查:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/security-inspect/ship-new-security-total-new',
          name: 'security-check-statistic-new',
          component: () =>
            import(
              '@/views/ism-management/security-check-new/security-check-statistic-new'
            ),
          meta: {
            title: '检查次数',
            access: '船舶检查检查次数统计',
          },
        },
      ],
    },
    {
      title: '船舶风险防控',
      title_EN: 'Ship Risk Prevention',
      icon: 'mdi-account-group',
      group: '/ship-risk-prevent',
      children: [
        {
          path: '/ship-risk-prevent/risk-type',
          name: 'risk-type',
          component: () =>
            import(
              '@/views/safety-supervision/ship-risk-prevent/risk-type.vue'
            ),
          meta: {
            title: '风险类别',
            access: '风险类别:列表',
          },
        },
        {
          path: '/ship-risk-prevent/bus-type',
          name: 'bus-type',
          component: () =>
            import('@/views/safety-supervision/ship-risk-prevent/bus-type.vue'),
          meta: {
            title: '业务类型',
            access: '业务类型:列表',
          },
        },
        {
          path: '/ship-risk-prevent/ship-important-check-list',
          name: 'ship-important-check-list',
          component: () =>
            import(
              '@/views/safety-supervision/ship-risk-prevent/ship-important-check-list.vue'
            ),
          meta: {
            title: '防控清单',
            access: '风险防控清单:列表',
          },
        },
        {
          path: '/ship-risk-prevent/ship-important-check-list-detail/:id',
          name: 'ship-important-check-list-detail',
          component: () =>
            import(
              '@/views/safety-supervision/ship-risk-prevent/ship-important-check-list-detail.vue'
            ),
          meta: {
            title: '防控清单',
            access: '风险防控清单:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/ship-risk-prevent/ship-identify-check-list',
          name: 'ship-identify-check-list',
          component: () =>
            import(
              '@/views/safety-supervision/ship-risk-prevent/ship-identify-check-list.vue'
            ),
          meta: {
            title: '识别清单',
            access: '风险识别清单:列表',
          },
        },
        {
          path: '/ship-risk-prevent/ship-identify-check-list-detail/:id',
          name: 'ship-identify-check-list-detail',
          component: () =>
            import(
              '@/views/safety-supervision/ship-risk-prevent/ship-identify-check-list-detail.vue'
            ),
          meta: {
            title: '识别清单',
            access: '风险识别清单:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/ship-risk-prevent/ship-correct',
          name: 'ship-correct',
          component: () =>
            import(
              '@/views/safety-supervision/ship-risk-prevent/ship-correct.vue'
            ),
          meta: {
            title: '船舶整改',
            access: '船舶整改:列表',
          },
        },
        {
          path: '/ship-risk-prevent/ship-correct-detail/:id',
          name: 'ship-correct-detail',
          component: () =>
            import(
              '@/views/safety-supervision/ship-risk-prevent/ship-correct-detail.vue'
            ),
          meta: {
            title: '船舶整改详情',
            access: '船舶整改:列表',
            notShowInNav: true,
          },
        },
      ],
    },
    {
      title: '船舶登轮检查基准',
      title_EN: 'Quarterly Ship Inspection Base Info',
      icon: 'mdi-text-box-outline',
      group: '/base',
      children: [
        {
          path: '/quarter-ship-inspect-assess/base/check-score-origin-type',
          name: 'check-score-origin-type',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/check-score-origin-type.vue'
            ),
          meta: {
            title: '打分一级分类',
            access: '打分总类:列表',
          },
        },
        {
          path: '/quarter-ship-inspect-assess/base/check-score-type',
          name: 'check-score-type',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/check-score-type.vue'
            ),
          meta: {
            title: '打分二级分类',
            access: '打分类别:列表',
          },
        },
        {
          path: '/ship-risk-prevent/base/ship-check-add-item',
          name: 'ship-check-add-item',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/ship-check-add-item.vue'
            ),
          meta: {
            title: '打分项目库',
            access: '船舶检查打分项目库:列表',
          },
        },
        {
          path: '/quarter-ship-inspect-assess/base/check-deduct-type',
          name: 'check-deduct-type',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/check-deduct-type.vue'
            ),
          meta: {
            title: '扣分分类',
            access: '扣分类别:列表',
          },
        },
        {
          path: '/ship-risk-prevent/base/ship-check-deduct-item',
          name: 'ship-check-deduct-item',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/ship-check-deduct-item.vue'
            ),
          meta: {
            title: '扣分项目库',
            access: '船舶检查扣分项目库:列表',
          },
        },
        {
          path: '/quarter-ship-inspect-assess/base/check-plus-type',
          name: 'check-plus-type',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/check-plus-type.vue'
            ),
          meta: {
            title: '加分分类',
            access: '加分类别:列表',
          },
        },
        {
          path: '/ship-risk-prevent/base/ship-check-plus-item',
          name: 'ship-check-plus-item',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/ship-check-plus-item.vue'
            ),
          meta: {
            title: '加分项目库',
            access: '船舶检查加分项目库:列表',
          },
        },
        {
          path: '/quarter-ship-inspect-assess/base/ship-check-score-standard',
          name: 'ship-check-score-standard',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/ship-check-score-standard.vue'
            ),
          meta: {
            title: '船舶标准分',
            access: '船舶标准分:列表',
          },
        },
        {
          path: '/ship-risk-prevent/base/ship-check-add-template',
          name: 'ship-check-add-template',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/ship-check-add-template.vue'
            ),
          meta: {
            title: '打分模板',
            access: '船舶检查打分模板:列表',
          },
        },
        {
          path: '/ship-risk-prevent/base/ship-check-add-template-detail/:id',
          name: 'ship-check-add-template-detail',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/ship-check-add-template-detail.vue'
            ),
          meta: {
            title: '打分模板',
            access: '船舶检查打分模板:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/ship-risk-prevent/base/ship-check-deduct-template',
          name: 'ship-check-deduct-template',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/ship-check-deduct-template.vue'
            ),
          meta: {
            title: '扣分模板',
            access: '船舶检查扣分模板:列表',
          },
        },
        {
          path: '/ship-risk-prevent/base/ship-check-deduct-template-detail/:id',
          name: 'ship-check-deduct-template-detail',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/ship-check-deduct-template-detail.vue'
            ),
          meta: {
            title: '扣分模板',
            access: '船舶检查扣分模板:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/ship-risk-prevent/base/ship-check-plus-template',
          name: 'ship-check-plus-template',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/ship-check-plus-template.vue'
            ),
          meta: {
            title: '加分模板',
            access: '船舶检查加分模板:列表',
          },
        },
        {
          path: '/ship-risk-prevent/base/ship-check-plus-template-detail/:id',
          name: 'ship-check-plus-template-detail',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/ship-check-plus-template-detail.vue'
            ),
          meta: {
            title: '加分模板',
            access: '船舶检查加分模板:列表',
            notShowInNav: true,
          },
        },
      ],
    },
    {
      title: '安监考评',
      title_EN: 'Quarterly Ship Inspection and Assessment',
      icon: 'mdi-application-edit-outline',
      group: '/quarter-ship-inspect-assess',
      children: [
        {
          path: '/ship-risk-prevent/ship-quarter-check',
          name: 'ship-quarter-check',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/ship-quarter-check.vue'
            ),
          meta: {
            title: '季度考评',
            access: '船舶季度检查考评:列表',
          },
        },
        {
          path: '/ship-risk-prevent/ship-quarter-check-detail/:id',
          name: 'ship-quarter-check-detail',
          component: () =>
            import(
              '@/views/safety-supervision/quarter-ship-inspect-assess/ship-quarter-check-detail.vue'
            ),
          meta: {
            title: '季度考评',
            access: '船舶季度检查考评:列表',
            notShowInNav: true,
          },
        },
      ],
    },
    {
      title: '船舶事故',
      title_EN: 'Ship Accident',
      icon: 'mdi-sail-boat-sink',
      group: '/ship-accident',
      children: [
        {
          path: '/safety-supervision/ship-accident/report-escalation',
          name: 'report-escalation',
          component: () =>
            import(
              '@/views/safety-supervision/ship-accident/report-escalation.vue'
            ),
          meta: {
            title: '事故上报',
            access: '事故上报:列表',
          },
        },
        {
          path: '/safety-supervision/ship-accident/report-escalation-detail/:id',
          name: 'report-escalation-detail',
          component: () =>
            import(
              '@/views/safety-supervision/ship-accident/report-escalation-detail.vue'
            ),
          meta: {
            title: '事故上报详情',
            access: '事故上报:列表',
            notShowInNav: true,
          },
        },
      ],
    },
  ],
}
